import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { DateTableColumn, NumberTableColumn, TextTableColumn } from '../../../components/kiene-table/table-column';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';

@Component({
    selector: 'kiene-material-historie-dialog',
    templateUrl: './material-historie-dialog.component.html',
    styleUrls: ['./material-historie-dialog.component.scss'],
})
export class MaterialHistorieDialogComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialogRef: MatDialogRef<MaterialHistorieDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        const params = new HttpParams().set('artikel_id', this.data.artikel_id);
        this.tableDescriptor.headline = 'Artikel Verkaufspreis Historie';
        this.tableDescriptor.uniqueIdentifier = 'Artikel-Verkaufspreis-Historie';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'artikel_verkaufspreis_historie/';
        this.tableDescriptor.params = params;
        this.tableDescriptor.initialSortColumn = 'editiert';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.columns = [
            new TextTableColumn('avh_id', 'ID'),
            new TextTableColumn('artikel', 'Artikel'),
            new TextTableColumn('verkaufspreis', 'Verkauf'),
            new NumberTableColumn('einzelpreis', 'Einzelpreis', '1.2-2', '€'),
            new DateTableColumn('editiert', 'Editiert'),
            new TextTableColumn('editiert_von', 'Editiert von'),
        ];

        this.tableDescriptor.permissionView = 1000;
    }
}
